/**
 * @generated SignedSource<<b8e1760886b567a604a34af69b96908d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchAssetsObjectType_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultAssetsObjectType";
  readonly description: string;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly objectSchemaEntity: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly objectTypeEntity: {
    readonly icon: {
      readonly url48: string | null | undefined;
    } | null | undefined;
    readonly links: {
      readonly web: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly " $fragmentType": "searchAssetsObjectType_AtlassianSearchPage";
};
export type searchAssetsObjectType_AtlassianSearchPage$key = {
  readonly " $data"?: searchAssetsObjectType_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchAssetsObjectType_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchAssetsObjectType_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "AssetsSchema",
      "kind": "LinkedField",
      "name": "objectSchemaEntity",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    },
    {
      "concreteType": "AssetsObjectType",
      "kind": "LinkedField",
      "name": "objectTypeEntity",
      "plural": false,
      "selections": [
        {
          "concreteType": "AssetsIcon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "url48"
            }
          ]
        },
        {
          "concreteType": "AssetsLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "web"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultAssetsObjectType"
};

(node as any).hash = "413e6bbad4a1a59e111fea1b1a76dab9";

export default node;
